package kz.dentalcrm.app.screens.services.services.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.services.ServiceItem
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface ServicesViewEvent : ViewEvent {

    data object AddServiceCategory : ServicesViewEvent

    data object Reload : ServicesViewEvent

    data class SearchService(
        val search: String
    ) : ServicesViewEvent

    data class ServiceCategorySelected(
        val category: ServiceCategory
    ) : ServicesViewEvent

    data object ClearSelectedCategories : ServicesViewEvent

    data class EditService(
        val service: ServiceItem
    ): ServicesViewEvent

    data class DeleteService(val id: Int) : ServicesViewEvent

    data object LoadMore : ServicesViewEvent
}